export const COLUMNS = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  key: '1',
  align: 'center',
  width: 100,
  scopedSlots: {
    customRender: 'index'
  }
}, {
  slots: {
    title: '统计机构'
  },
  dataIndex: 'organizationName',
  key: '2',
  align: 'center'
}, {
  slots: {
    title: '统计月份'
  },
  dataIndex: 'date',
  key: '3',
  align: 'center',
  width: 100
}, {
  slots: {
    title: '公司现有人数'
  },
  dataIndex: 'peopleNum',
  key: '4',
  align: 'center',
  width: 150
}, {
  slots: {
    title: '同比（+/-）'
  },
  dataIndex: 'grew',
  key: '5',
  align: 'center',
  width: 150
}, {
  slots: {
    title: '总持证数'
  },
  dataIndex: 'licensesNum',
  key: '6',
  align: 'center',
  width: 100
}, {
  slots: {
    title: '高级管理人员'
  },
  dataIndex: 'adminNum',
  key: '7',
  align: 'center',
  width: 150
}, {
  slots: {
    title: '操作'
  },
  key: '8',
  align: 'center',
  scopedSlots: {
    customRender: 'action'
  },
  width: 200
}];
export const data = [{
  organizationName: '泛华保险服务集团',
  date: '2020-3',
  peopleNum: '234',
  grew: '5',
  licensesNum: '78',
  adminNum: '10',
  adminLicensesNum: '30',
  businessNum: '50',
  businessLicensesNum: '40',
  onBusinessNum: '100',
  onBusinessLicensesNum: '70',
  id: '1'
}, {
  organizationName: '泛华保险服务集团',
  date: '2020-3',
  peopleNum: '234',
  grew: '5',
  licensesNum: '78',
  adminNum: '10',
  adminLicensesNum: '30',
  businessNum: '50',
  businessLicensesNum: '40',
  onBusinessNum: '100',
  onBusinessLicensesNum: '70',
  id: '2'
}, {
  organizationName: '泛华保险服务集团',
  date: '2020-3',
  peopleNum: '234',
  grew: '5',
  licensesNum: '78',
  adminNum: '10',
  adminLicensesNum: '30',
  businessNum: '50',
  businessLicensesNum: '40',
  onBusinessNum: '100',
  onBusinessLicensesNum: '70',
  id: '3'
}, {
  organizationName: '泛华保险服务集团',
  date: '2020-3',
  peopleNum: '234',
  grew: '5',
  licensesNum: '78',
  adminNum: '10',
  adminLicensesNum: '30',
  businessNum: '50',
  businessLicensesNum: '40',
  onBusinessNum: '100',
  onBusinessLicensesNum: '70',
  id: '4'
}, {
  organizationName: '泛华保险服务集团',
  date: '2020-3',
  peopleNum: '234',
  grew: '5',
  licensesNum: '78',
  adminNum: '10',
  adminLicensesNum: '30',
  businessNum: '50',
  businessLicensesNum: '40',
  onBusinessNum: '100',
  onBusinessLicensesNum: '70',
  id: '5'
}];